/* ============================================================
   Plant Styling — Tumbleweed Plants
   Shopify OS 2.0 — Shared interactions
   Scoped to .tbw-ps root.
   ============================================================ */
(function () {
  'use strict';

  // ---------- Reveal on scroll ----------
  function initReveal() {
    if (typeof IntersectionObserver === 'undefined') {
      document.querySelectorAll('.tbw-ps [data-reveal]').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('.tbw-ps [data-reveal]:not(.in), .tbw-ps .underline:not(.in)').forEach(function (el) { io.observe(el); });
  }

  // ---------- Hero stage fade-in ----------
  function initHero() {
    document.querySelectorAll('.tbw-ps .hero-stage').forEach(function (stage) {
      requestAnimationFrame(function () { stage.classList.add('in'); });
    });
  }

  // ---------- Before/After drag slider (V2Transform) ----------
  function initBeforeAfter() {
    document.querySelectorAll('.tbw-ps .ba').forEach(function (wrap) {
      var after = wrap.querySelector('.after');
      var handle = wrap.querySelector('.handle');
      if (!after || !handle) return;
      var dragging = false;
      function setPos(clientX) {
        var r = wrap.getBoundingClientRect();
        var p = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
        after.style.clipPath = 'inset(0 0 0 ' + p + '%)';
        handle.style.left = p + '%';
      }
      wrap.addEventListener('pointerdown', function (e) {
        dragging = true;
        wrap.setPointerCapture(e.pointerId);
        setPos(e.clientX);
      });
      wrap.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        e.preventDefault();
        setPos(e.clientX);
      });
      wrap.addEventListener('pointerup', function () { dragging = false; });
      wrap.addEventListener('pointercancel', function () { dragging = false; });
    });
  }

  // ---------- Portfolio horizontal scroll ----------
  function initFolio() {
    document.querySelectorAll('.tbw-ps .folio-scroll').forEach(function (scope) {
      var track = scope.querySelector('.folio-track');
      var fill = scope.querySelector('.folio-nav .fill');
      var prev = scope.querySelector('[data-folio-prev]');
      var next = scope.querySelector('[data-folio-next]');
      if (!track) return;
      function updateProgress() {
        if (!fill) return;
        var max = track.scrollWidth - track.clientWidth;
        var p = max > 0 ? (track.scrollLeft / max) * 100 : 0;
        fill.style.width = p + '%';
      }
      track.addEventListener('scroll', updateProgress, { passive: true });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -560, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: 560, behavior: 'smooth' }); });
      updateProgress();
    });
  }

  // ---------- Testimonials rotator ----------
  function initTesti() {
    document.querySelectorAll('.tbw-ps .testi-stage').forEach(function (stage) {
      var quotes = stage.querySelectorAll('.q-wrap .q');
      var authors = stage.querySelectorAll('.by-wrap .by');
      var dots = stage.querySelectorAll('.testi-dots button');
      if (!quotes.length) return;
      var idx = 0;
      function show(i) {
        quotes.forEach(function (q, n) { q.classList.toggle('active', n === i); });
        authors.forEach(function (a, n) { a.style.display = n === i ? 'flex' : 'none'; });
        dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
        idx = i;
      }
      show(0);
      dots.forEach(function (d, n) { d.addEventListener('click', function () { show(n); resetTimer(); }); });
      var timer;
      function resetTimer() {
        clearInterval(timer);
        timer = setInterval(function () { show((idx + 1) % quotes.length); }, 6500);
      }
      resetTimer();
    });
  }

  // ---------- Scroll-scrubbed transformation (SST) ----------
  function initSST() {
    var section = document.querySelector('.tbw-ps .sst');
    if (!section) return;
    var afterLayer = section.querySelector('.sst-after');
    var beforeLayer = section.querySelector('.sst-before');
    var edge = section.querySelector('.sst-edge');
    var vignette = section.querySelector('.sst-vignette');
    var grain = section.querySelector('.sst-grain');
    var fill = section.querySelector('.sst-scrub-fill');
    var head = section.querySelector('.sst-scrub-head');
    var pct = section.querySelector('.sst-scrub-pct');
    var beats = section.querySelectorAll('.sst-beat');
    var marks = section.querySelectorAll('.sst-mark');
    var tagL = section.querySelector('.sst-tag-l');
    var tagR = section.querySelector('.sst-tag-r');
    var hint = section.querySelector('.sst-hint');
    var beatData = Array.prototype.map.call(beats, function (b) { return parseFloat(b.getAttribute('data-p')) || 0; });

    function ease(t) { return t * t * (3 - 2 * t); }

    function onScroll() {
      var r = section.getBoundingClientRect();
      var total = section.offsetHeight - window.innerHeight;
      var scrolled = Math.max(0, Math.min(total, -r.top));
      var p = total > 0 ? scrolled / total : 0;
      var pe = ease(p);
      var wipeX = 100 - pe * 100;
      var scale = 1 + pe * 0.08;
      var vig = 0.55 - pe * 0.35;
      var grn = 0.35 - pe * 0.2;
      if (afterLayer) afterLayer.style.transform = 'scale(' + scale + ')';
      if (beforeLayer) {
        beforeLayer.style.transform = 'scale(' + scale + ')';
        beforeLayer.style.clipPath = 'inset(0 0 0 ' + (100 - wipeX) + '%)';
      }
      if (edge) {
        edge.style.left = (100 - wipeX) + '%';
        edge.style.opacity = (p > 0.02 && p < 0.98) ? 1 : 0;
      }
      if (vignette) vignette.style.opacity = vig;
      if (grain) grain.style.opacity = grn;
      if (fill) fill.style.width = (pe * 100) + '%';
      if (head) head.style.left = (pe * 100) + '%';
      if (pct) pct.textContent = String(Math.round(pe * 100)).padStart(2, '0') + '%';
      if (tagL) tagL.classList.toggle('on', p < 0.5);
      if (tagL) tagL.classList.toggle('off', p >= 0.5);
      if (tagR) tagR.classList.toggle('on', p >= 0.5);
      if (tagR) tagR.classList.toggle('off', p < 0.5);
      if (hint) hint.style.opacity = p < 0.03 ? 1 : 0;
      var active = 0;
      for (var i = 0; i < beatData.length; i++) {
        if (p >= beatData[i] - 0.12) active = i;
      }
      beats.forEach(function (b, n) { b.classList.toggle('on', n === active); });
      marks.forEach(function (m, n) { m.classList.toggle('on', n <= active); });
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  // ---------- Sticky CTA ----------
  function initStickyCta() {
    var el = document.querySelector('.tbw-sticky-cta');
    if (!el) return;
    function onScroll() {
      var y = window.scrollY;
      var bookEl = document.getElementById('book');
      var closer = document.querySelector('.tbw-ps .closer');
      if (!bookEl) { el.classList.remove('on'); return; }
      var showIt = y > window.innerHeight * 0.8 && (bookEl.getBoundingClientRect().top > 400 || (closer && closer.getBoundingClientRect().top < window.innerHeight));
      el.classList.toggle('on', !!showIt);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---------- Hero marquee (clone track for seamless loop if needed) ----------
  function initMarquee() {
    document.querySelectorAll('.tbw-ps .hero-marquee .hm-track').forEach(function (track) {
      // If already cloned (server-rendered with duplicate items), skip
      if (track.dataset.cloned === 'true') return;
      var kids = Array.prototype.slice.call(track.children);
      if (kids.length < 6) return; // not enough items to meaningfully loop
      // Duplicate for infinite scroll
      kids.forEach(function (k) { track.appendChild(k.cloneNode(true)); });
      track.dataset.cloned = 'true';
    });
  }

  // ---------- Booking v3: session picker + calendar mock ----------
  function initBookingV3() {
    document.querySelectorAll('.tbw-ps [data-booking-v3]').forEach(function (bw) {
      var picker = bw.querySelectorAll('.bv3-opt');
      var calT = bw.querySelector('.bv3-cal-t');
      var calS = bw.querySelector('.bv3-cal-s');
      var ctaText = bw.querySelector('[data-cta-text]');
      var cta = bw.querySelector('[data-cta-link]');

      // Session switching
      picker.forEach(function (opt) {
        opt.addEventListener('click', function () {
          picker.forEach(function (o) { o.classList.remove('on'); });
          opt.classList.add('on');
          var name = opt.getAttribute('data-n');
          var dur = opt.getAttribute('data-d');
          var price = opt.getAttribute('data-p');
          var sub = opt.getAttribute('data-sub');
          var href = opt.getAttribute('data-href');
          if (calT) calT.textContent = name;
          if (calS) calS.innerHTML = dur + ' · <b>' + price + '</b>' + (sub ? ' · <span>' + sub + '</span>' : '');
          if (ctaText) {
            ctaText.textContent = (price === 'Free' || price === 'FREE')
              ? 'Book free call'
              : 'Confirm & pay ' + price;
          }
          if (cta && href) cta.setAttribute('href', href);
        });
      });

      // Calendar day picker
      var days = bw.querySelectorAll('.am-cell:not(.pad):not(.busy)');
      var dateLabel = bw.querySelector('.am-date b');
      var monthName = bw.querySelector('.am-cal-top .m');
      days.forEach(function (d) {
        d.addEventListener('click', function () {
          days.forEach(function (x) { x.classList.remove('on'); });
          d.classList.add('on');
          if (dateLabel) {
            var dayNum = d.textContent.trim();
            var monthStr = monthName ? monthName.textContent.trim() : '';
            dateLabel.textContent = dayNum + ' ' + monthStr;
          }
        });
      });

      // Slot picker
      var slots = bw.querySelectorAll('.am-slot');
      slots.forEach(function (s) {
        s.addEventListener('click', function () {
          slots.forEach(function (x) { x.classList.remove('on'); });
          s.classList.add('on');
        });
      });
    });
  }

  // ---------- OLD Booking form: 3-step flow (kept for backwards-compatibility if using old booking section) ----------
  function initBooking() {
    document.querySelectorAll('.tbw-ps .bw[data-booking]').forEach(function (bw) {
      var form = bw.querySelector('form');
      var steps = bw.querySelectorAll('.bw-stepview');
      var stepInd = bw.querySelectorAll('.bw-step');
      var stepSpan = bw.querySelector('.bw-step-num');
      var btnNext = bw.querySelector('[data-bw-next]');
      var btnBack = bw.querySelector('[data-bw-back]');
      var btnSubmit = bw.querySelector('[data-bw-submit]');
      var footSum = bw.querySelector('.bw-foot-sum');
      var success = bw.querySelector('.bw-success');
      var svcTabs = bw.querySelectorAll('[data-svc-tab]');
      var svcLists = bw.querySelectorAll('[data-svc-list]');
      var svcRadios = bw.querySelectorAll('[data-bw-svc]');
      var roomBtns = bw.querySelectorAll('[data-bw-rooms]');
      var svcHidden = bw.querySelector('input[name="service"]');
      var roomHidden = bw.querySelector('input[name="home_size"]');
      var current = 1;
      var total = steps.length;

      function render() {
        steps.forEach(function (s, i) { s.style.display = (i + 1 === current) ? 'block' : 'none'; });
        stepInd.forEach(function (s, i) {
          s.classList.toggle('on', i + 1 === current);
          s.classList.toggle('done', i + 1 < current);
          var n = s.querySelector('.n');
          if (n) n.textContent = (i + 1 < current) ? '✓' : String(i + 1);
        });
        if (stepSpan) stepSpan.textContent = current;
        if (btnBack) btnBack.style.display = current > 1 ? 'inline-block' : 'none';
        if (footSum) footSum.style.display = current === 1 ? 'block' : 'none';
        if (btnNext) btnNext.style.display = current < total ? 'inline-flex' : 'none';
        if (btnSubmit) btnSubmit.style.display = current === total ? 'inline-flex' : 'none';
      }

      // Service tabs
      svcTabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-svc-tab');
          svcTabs.forEach(function (t) { t.classList.toggle('on', t === tab); });
          svcLists.forEach(function (l) { l.style.display = l.getAttribute('data-svc-list') === key ? 'block' : 'none'; });
          var firstRadio = bw.querySelector('[data-svc-list="' + key + '"] input[type="radio"]');
          if (firstRadio) { firstRadio.checked = true; firstRadio.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      });

      // Service radio → updates footer summary + hidden input
      svcRadios.forEach(function (label) {
        var input = label.querySelector('input[type="radio"]');
        if (!input) return;
        input.addEventListener('change', function () {
          svcRadios.forEach(function (l) { l.classList.toggle('on', l.querySelector('input').checked); });
          if (input.checked) {
            if (svcHidden) svcHidden.value = label.getAttribute('data-svc-name') || input.value;
            var priceEl = label.querySelector('.svc-p');
            var nameEl = label.querySelector('.svc-n');
            if (footSum && priceEl && nameEl) {
              footSum.innerHTML = '<b>' + nameEl.textContent + '</b>' + priceEl.textContent + ' · credited if you proceed';
            }
          }
        });
        label.addEventListener('click', function (e) {
          if (e.target.tagName !== 'INPUT') { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      });

      // Rooms toggle
      roomBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          roomBtns.forEach(function (b) { b.classList.toggle('on', b === btn); });
          if (roomHidden) roomHidden.value = btn.getAttribute('data-bw-rooms');
        });
      });

      if (btnNext) btnNext.addEventListener('click', function (e) {
        e.preventDefault();
        if (current < total) { current++; render(); }
      });
      if (btnBack) btnBack.addEventListener('click', function (e) {
        e.preventDefault();
        if (current > 1) { current--; render(); }
      });

      if (form) {
        form.addEventListener('submit', function (e) {
          // If the wrapper has a data-endpoint, intercept and POST via fetch.
          // Otherwise let Shopify's {% form 'contact' %} submit natively.
          var endpoint = bw.getAttribute('data-endpoint');
          if (!endpoint) return; // native submit
          e.preventDefault();
          var data = new FormData(form);
          fetch(endpoint, { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
            .then(function () {
              if (success) {
                form.style.display = 'none';
                success.style.display = 'block';
              }
            })
            .catch(function () { alert('Could not send right now. Please WhatsApp us instead.'); });
        });
      }

      // Initial state
      var checkedRadio = bw.querySelector('input[type="radio"]:checked');
      if (checkedRadio) checkedRadio.dispatchEvent(new Event('change', { bubbles: true }));
      render();
    });
  }

  // ---------- Init ----------
  function init() {
    initReveal();
    initHero();
    initBeforeAfter();
    initFolio();
    initTesti();
    initSST();
    initStickyCta();
    initBooking();
    initBookingV3();
    initMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify theme editor updates a section
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
